import * as React from 'react';
import { jsx } from 'react/jsx-runtime';

var Context = /*#__PURE__*/React.createContext(null);
var TreeA11yContext = function TreeA11yContext(props) {
  var context = {
    draggedNodeId: props.draggedNodeId,
    focusedNodeId: props.focusedNodeId,
    focusedDropRegion: props.focusedDropRegion
  };
  return /*#__PURE__*/jsx(Context.Provider, {
    value: context,
    children: props.children
  });
};
function useTreeA11yContext() {
  var context = React.useContext(Context);
  if (context === null) {
    throw new TypeError("No TreeA11yContext provided");
  }
  return context;
}

export { TreeA11yContext, useTreeA11yContext };
